import Newsletter from './Newsletter.js'
export default Newsletter;
